import { H2 } from '@ahmdigital/ui';
import { useFormikContext } from 'formik';
import React, { useEffect, useState } from 'react';

import {
  ContentWrapper,
  Disclaimer,
  MaxTravellerCountP,
  PromoField,
  PromoLabel,
  PromoLabelWrapper,
  PromoP,
  StyledCheckbox,
  StyledClickable,
} from './styles';
import { DEPENDENT_MESSAGE_DELAY, FIELD_NAMES } from '../../constants';
import { FormValues } from '../../types';
import getHasChildDependents from '../../utils/get-has-chilld-dependents';
import getTravelInsuranceConstants from '../../../../../../utils/get-travel-insurance-constants';
import TravellerCounter from './components/traveller-counter';
import TravellerField from './components/traveller-field';
import useTravelWidgetContext from '../../hooks/use-travel-widget-context';

const MAX_TRAVELLER_COUNT = 9;

const { CONTACT } = getTravelInsuranceConstants();

const TravellerDetails = () => {
  const { travellerCount, setTravellerCount } = useTravelWidgetContext();
  const { values } = useFormikContext<FormValues>();
  const [delayedHasDependents, setDelayedHasDependents] = useState(getHasChildDependents({ formikValues: values }));

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDelayedHasDependents(getHasChildDependents({ formikValues: values }));
    }, DEPENDENT_MESSAGE_DELAY);
    return () => clearTimeout(timeout);
  }, [values]);

  return (
    <ContentWrapper>
      <H2 looksLike="h5" variant="marginBottomSpacer9">
        Traveller details
      </H2>
      <TravellerField
        helperText="Current age of traveller"
        labelText="Primary traveller"
        name={FIELD_NAMES.TRAVELLER_AGE_1}
        required
      />
      {travellerCount === MAX_TRAVELLER_COUNT && (
        <MaxTravellerCountP>
          If there are more than 10 travellers please contact our Customer Service team on{' '}
          <StyledClickable to={`tel:${CONTACT.PHONE.STANDARD}`}>{CONTACT.PHONE.PRETTY}</StyledClickable> to discuss your
          travel insurance options.
        </MaxTravellerCountP>
      )}
      <TravellerCounter travellerCount={travellerCount} setTravellerCount={setTravellerCount} />
      {Array.from({ length: travellerCount }, (_, index) => {
        const travellerIndex = index + 2;
        return (
          <TravellerField
            key={index}
            labelText={`Traveller ${travellerIndex}`}
            name={`travelerAge_${travellerIndex}`}
            helperText={`Current age of traveller ${travellerIndex}`}
            id={`traveller-${travellerIndex}`}
          />
        );
      })}
      {delayedHasDependents && (
        <Disclaimer variant={['marginBottomSpacer9', 'small14']}>
          ^Cover is included for anyone under 18 who is identified on the certificate of insurance and travelling with
          you.
        </Disclaimer>
      )}
      <StyledCheckbox
        // @ts-expect-error [🤖 PLEASE FIX 🤖]: No overload matches this call.
        fieldLabel="All travellers currently live in Australia and hold a valid Australian Medicare card or visa allowing them to live, work or study in Australia."
        name="resident"
        type="checkbox"
        isRequired
      />
      {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: No overload matches this call. */}
      <StyledCheckbox fieldLabel="Are you an ahm or Medibank health member?" name="isMember" type="checkbox" />
      <PromoLabelWrapper>
        <PromoLabel htmlFor="promoCode">Promo code </PromoLabel>
        <PromoP>(Optional)</PromoP>
      </PromoLabelWrapper>
      {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: No overload matches this call. */}
      <PromoField name="promoCode" type="text" />
    </ContentWrapper>
  );
};

export default TravellerDetails;
